<script>
  export default {
    name: 'InteractiveFormActionButtonBlock',
    props: {
      withPressEnter: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      handleClick() {
        if (!this.disabled) {
          this.$emit('click')
        }
      },
    },
  }
</script>

<template>
  <div class="interactive-form-action-button-block">
    <div
      class="interactive-form-action-button-block__button"
      :class="{
        'interactive-form-action-button-block__button--disabled': disabled,
      }"
      :aria-disabled="disabled"
      :style="disabled ? 'pointer-events: none; opacity: 0.6;' : ''"
      @click="handleClick"
    >
      <slot name="button-content"></slot>
    </div>
    <span
      v-if="withPressEnter"
      class="interactive-form-action-button-block__press-enter"
    >
      Press
      <span class="font-weight-bold">Enter ↵</span>
    </span>
  </div>
</template>

<style scoped>
  .interactive-form-action-button-block__button--disabled {
    pointer-events: none;
    opacity: 0.6;
  }
</style>
